module.exports = __webpack_public_path__ + "static/media/vinylot.1faa31e1.woff2";